import { render } from "./FooterRow.vue?vue&type=template&id=ea801bee&scoped=true"
import script from "./FooterRow.vue?vue&type=script&lang=js"
export * from "./FooterRow.vue?vue&type=script&lang=js"

import "./FooterRow.vue?vue&type=style&index=0&id=ea801bee&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea801bee"]])

export default __exports__